export const usageTypes = [
  { key: "DOSSIERS", name: "Dossiers" },
  { key: "DAILYSCHEDULE", name: "DailySchedule" },
]